import { defineMessages } from 'react-intl';

export default defineMessages({
  achRelationshipId: {
    id: 'sentinel.components.searchResultsTable.column.achRelationshipId',
    defaultMessage: 'ACH Relationship ID',
  },
  amount: {
    id: 'sentinel.components.searchResultsTable.column.amount',
    defaultMessage: 'Amount',
  },
  apexAccountNumber: {
    id: 'sentinel.components.searchResultsTable.column.apexAccountNumber',
    defaultMessage: 'Clearing Account',
  },
  bankAccountIdentifierValue: {
    id: 'sentinel.components.searchResultsTable.column.bankAccountIdentifierValue',
    defaultMessage: 'ABA / BIC',
  },
  bankAccountNumber: {
    id: 'sentinel.components.searchResultsTable.column.bankAccountNumber',
    defaultMessage: 'Bank Account Number',
  },
  bankAccountType: {
    id: 'sentinel.components.searchResultsTable.column.bankAccountType',
    defaultMessage: 'Bank Account Type',
  },
  batchId: {
    id: 'sentinel.components.searchResultsTable.column.batchId',
    defaultMessage: 'Batch ID',
  },
  correspondentCode: {
    id: 'sentinel.components.searchResultsTable.column.correspondentCode',
    defaultMessage: 'Corr Code',
  },
  // FEECM-16278: remove 'corr deposit' column from grid
  // correspondentDeposit: {
  //   id: 'sentinel.components.searchResultsTable.column.correspondentDeposit',
  //   defaultMessage: 'Corr Deposit',
  // },
  correspondentName: {
    id: 'sentinel.components.searchResultsTable.column.correspondentName',
    defaultMessage: 'Corr',
  },
  ctsId: {
    id: 'sentinel.components.searchResultsTable.column.ctsId',
    defaultMessage: 'CTS ID',
  },
  date: {
    id: 'sentinel.components.searchResultsTable.column.date',
    defaultMessage: 'Date',
  },
  destinationAccount: {
    id: 'sentinel.components.searchResultsTable.column.destinationAccount',
    defaultMessage: 'Destination Account',
  },
  destinationCountry: {
    id: 'sentinel.components.searchResultsTable.column.destinationCountry',
    defaultMessage: 'Dest. Country',
  },
  direction: {
    id: 'sentinel.components.searchResultsTable.column.direction',
    defaultMessage: 'Direction',
  },
  emptySearchResults: {
    id: 'sentinel.components.searchResultsTable.emptySearchResults',
    description: 'The text displayed when there are no search results',
    defaultMessage: 'No search results',
  },
  exportToCsv: {
    id: 'sentinel.components.searchResultsTable.exportToCsv',
    defaultMessage: 'Export to CSV',
  },
  fedWireReferenceNumber: {
    id: 'sentinel.components.searchResultsTable.column.fedWireReferenceNumber',
    defaultMessage: 'Fed Ref #',
  },
  id: {
    id: 'sentinel.components.searchResultsTable.column.transferId',
    defaultMessage: 'Transfer ID',
  },
  instructionSource: {
    id: 'sentinel.components.searchResultsTable.column.instructionSource',
    defaultMessage: 'Instr. Src',
  },
  isFullDisbursement: {
    id: 'sentinel.components.searchResultsTable.column.isFullDisbursement',
    defaultMessage: 'Disbursement Type',
  },
  method: {
    id: 'sentinel.components.searchResultsTable.column.method',
    defaultMessage: 'Transfer Type',
  },
  prescribedActions: {
    id: 'sentinel.components.searchResultsTable.column.prescribedActions',
    defaultMessage: 'Prescribed Actions',
  },
  requestedAmount: {
    id: 'sentinel.components.searchResultsTable.column.requestedAmount',
    defaultMessage: 'Requested Amount',
  },
  sourceCountry: {
    id: 'sentinel.components.searchResultsTable.column.sourceCountry',
    defaultMessage: 'Src. Country',
  },
  state: {
    id: 'sentinel.components.searchResultsTable.column.state',
    defaultMessage: 'State',
  },
  programName: {
    id: 'sentinel.components.searchResultsTable.column.programName',
    defaultMessage: 'Program Name',
  },
  partial: {
    id: 'sentinel.components.searchResultsTable.partial',
    defaultMessage: 'Partial',
  },
  full: {
    id: 'sentinel.components.searchResultsTable.full',
    defaultMessage: 'Full',
  },
  externalId: {
    id: 'sentinel.components.searchResultsTable.column.externalId',
    defaultMessage: 'External ID',
  },
  houseBankAccountNumber: {
    id: 'sentinel.components.searchResultsTable.column.houseBankAccountNumber',
    defaultMessage: 'House Bank Acct.',
  },
  journalType: {
    id: 'sentinel.components.searchForm.journalType',
    defaultMessage: 'Journal Type',
  },
});



// WEBPACK FOOTER //
// ./src/components/SearchResultsTable/messages.js